<template lang="pug">
  .intel-avatar
    avataaars(
      avatar-style="Circle"
      :style="{'width': size + 'px'}"
      :accessoriesType="accessoriesType()"
      :clotheType="clotheType()"
      :clotheColor="clotheColor()"
      :eyebrowType="eyebrowType()"
      :eyeType="eyeType()"
      :facialHairColor="facialHairColor()"
      :facialHairType="facialHairType()"
      :graphicType="graphicType()"
      :hairColor="hairColor()"
      :topColor="hatColor()"
      :mouthType="mouthType()"
      :skinColor="skinColor()"
      :topType="topType()"
    )
</template>

<script>
export default {
  name: 'IntelAvatar',
  props: ['size', 'code', 'id'],
  data: () => ({
  }),
  computed: {
    randomCode () {
      return (
        'a' + (Number(this.id) % 33)
        + '-b' + (Number(this.id) % 12)
        + '-c' + (Number(this.id) % 12)
        + '-d' + (Number(this.id) % 11)
        + '-e' + (Number(this.id) % 7)
        + '-f' + (Number(this.id) % 7)
        + '-g' + (Number(this.id) % 9)
        + '-h' + (Number(this.id) % 10)
        + '-i' + (Number(this.id) % 15)
        + '-l' + (Number(this.id) % 15)
        + '-m' + (Number(this.id) % 11)
      )
      // return 'a32-b11-c6-d5-e0-f4-g5-h0-i0-l1-m0'
    },
    decodeAvatar () {
      let data = {}
      let dec = this.randomCode
      if (this.code) {
        dec = this.code
      }
      dec.split('-').forEach(o => {
        switch (o.substr(0, 1)) {
          case 'a':
            data.topType = o.substr(1)
            break
          case 'b':
            data.eyeType = o.substr(1)
            break
          case 'c':
            data.eyebrowType = o.substr(1)
            break
          case 'd':
            data.mouthType = o.substr(1)
            break
          case 'e':
            data.accessoriesType = o.substr(1)
            break
          case 'f':
            data.skinColor = o.substr(1)
            break
          case 'g':
            data.clotheType = o.substr(1)
            break
          case 'h':
            data.hairColor = o.substr(1)
            break
          case 'i':
            data.hatColor = o.substr(1)
            break
          case 'j':
            data.facialHairType = o.substr(1)
            break
          case 'k':
            data.facialHairColor = o.substr(1)
            break
          case 'l':
            data.clotheColor = o.substr(1)
            break
          case 'm':
            data.graphicType = o.substr(1)
            break
        }
      })
      // console.log(data)
      return data
    },
  },
  methods: {
    topType () {
      const items = [
        'NoHair',
        'Hat',
        'Turban',
        'WinterHat1',
        'WinterHat2',
        'WinterHat3',
        'WinterHat4',
        'LongHairBun',
        'LongHairDreads',
        'LongHairFro',
        'LongHairFroBand',
        'LongHairNotTooLong',
        'LongHairStraightStrand',
        'ShortHairDreads01',
        'ShortHairDreads02',
        'ShortHairFrizzle',
        'ShortHairShaggyMullet',
        'ShortHairShortCurly',
        'ShortHairShortFlat',
        'ShortHairShortRound',
        'ShortHairShortWaved',
        'ShortHairSides',
        'ShortHairTheCaesar',
        'ShortHairTheCaesarSidePart',
        'Hijab',
        'LongHairBigHair',
        'LongHairBob',
        'LongHairCurly',
        'LongHairCurvy',
        'LongHairFrida',
        'LongHairMiaWallace',
        'LongHairStraight',
        'LongHairStraight2',
      ]
      const index = this.decodeAvatar.topType
      return index ? items[index] : ''
    },
    hairColor () {
      const items = [
        'Black',
        'Auburn',
        'Blonde',
        'BlondeGolden',
        'Brown',
        'BrownDark',
        'PastelPink',
        'Platinum',
        'Red',
        'SilverGray'
      ]
      const index = this.decodeAvatar.hairColor
      return index ? items[index] : ''
    },
    hatColor () {
      const items = [
        'Black',
        'Blue01',
        'Blue02',
        'Blue03',
        'Gray01',
        'Gray02',
        'Heather',
        'PastelBlue',
        'PastelGreen',
        'PastelOrange',
        'PastelRed',
        'PastelYellow',
        'Pink',
        'Red',
        'White'
      ]
      const index = this.decodeAvatar.hatColor
      return index ? items[index] : ''
    },
    eyeType () {
      const items = [
        'Close',
        'Cry',
        'Default',
        'Dizzy',
        'EyeRoll',
        'Happy',
        'Hearts',
        'Side',
        'Squint',
        'Surprised',
        'Wink',
        'WinkWacky'
      ]
      const index = this.decodeAvatar.eyeType
      return index ? items[index] : ''
    },
    eyebrowType () {
      const items = [
        'Angry',
        'AngryNatural',
        'Default',
        'DefaultNatural',
        'FlatNatural',
        'RaisedExcited',
        'RaisedExcitedNatural',
        'SadConcerned',
        'SadConcernedNatural',
        'UnibrowNatural',
        'UpDown',
        'UpDownNatural'
      ]
      const index = this.decodeAvatar.eyebrowType
      return index ? items[index] : ''
    },
    mouthType () {
      const items = [
        'Concerned',
        'Default',
        'Disbelief',
        'Eating',
        'Grimace',
        'Sad',
        'ScreamOpen',
        'Serious',
        'Smile',
        'Tongue',
        'Twinkle'
      ]
      const index = this.decodeAvatar.mouthType
      return index ? items[index] : ''
    },
    accessoriesType () {
      const items = [
        'Blank',
        'Kurt',
        'Prescription01',
        'Prescription02',
        'Round',
        'Sunglasses',
        'Wayfarers'
      ]
      const index = this.decodeAvatar.accessoriesType
      return index ? items[index] : ''
    },
    facialHairType () {
      const items = [
        'Blank',
        'BeardMedium',
        'BeardLight',
        'BeardMajestic',
        'MoustacheFancy',
        'MoustacheMagnum'
      ]
      const index = this.decodeAvatar.facialHairType
      return index ? items[index] : ''
    },
    facialHairColor () {
      const items = [
        'Black',
        'Auburn',
        'Blonde',
        'BlondeGolden',
        'Brown',
        'BrownDark',
        'PastelPink',
        'Platinum',
        'Red',
        'SilverGray'
      ]
      const index = this.decodeAvatar.facialHairColor
      return index ? items[index] : ''
    },
    skinColor () {
      const items = [
        'Tanned',
        'Yellow',
        'Pale',
        'Light',
        'Brown',
        'DarkBrown',
        'Black'
      ]
      const index = this.decodeAvatar.skinColor
      return index ? items[index] : ''
    },
    clotheType () {
      const items = [
        'BlazerShirt',
        'BlazerSweater',
        'CollarSweater', 
        'GraphicShirt',
        'Hoodie',
        'Overall',
        'ShirtCrewNeck',
        'ShirtScoopNeck',
        'ShirtVNeck'
      ]
      const index = this.decodeAvatar.clotheType
      return index ? items[index] : ''
    },
    clotheColor () {
      const items = [
        'Black',
        'Blue01',
        'Blue02',
        'Blue03',
        'Gray01',
        'Gray02',
        'Heather',
        'PastelBlue',
        'PastelGreen',
        'PastelOrange',
        'PastelRed',
        'PastelYellow',
        'Pink',
        'Red',
        'White'
      ]
      const index = this.decodeAvatar.clotheColor
      return index ? items[index] : ''
    },
    graphicType () {
      const items = [
        'Bat',
        'Cumbia',
        'Deer',
        'Diamond',
        'Hola',
        'Pizza',
        'Resist',
        'Selena',
        'Bear',
        'SkullOutline',
        'Skull'
      ]
      const index = this.decodeAvatar.graphicType
      return index ? items[index] : ''
    },
  }
}
</script>